export default __webpack_public_path__ + "static/media/empty-recent-activity.304cbdbb.svg";